import React, { useEffect, useState } from 'react'

function DeleteModal({deleteRow,handleClose4,open4}) {
    const [deleteDisabled, setDeleteDisabled] = useState(true);
    const [progress, setProgress] = useState(0);
    
    useEffect(() => {
        if (open4) {
            let progressInterval;
            let timer = setTimeout(() => {
                setDeleteDisabled(false);
            }, 3000);

            progressInterval = setInterval(() => {
                setProgress((prev) => {
                  const newProgress = prev + 100 / 30;
                  if (newProgress >= 100) {
                    clearInterval(progressInterval);
                    return 100;
                  }
                  return newProgress;
                });
              }, 100);

            return () => {
                clearTimeout(timer);
                clearInterval(progressInterval);
                setProgress(0);
            };
        } else {
            setDeleteDisabled(true);
            setProgress(0);
        }
    }, [open4]);
  return (
    <>
         <h4 className='text-center font-bold  text-lg'>Record will be permanently deleted</h4>
                <div className='flex flex-row justify-evenly mt-5'>
                    <button
                        className={`${deleteDisabled?'bg-red-100 text-red-700':'bg-red-500 hover:bg-red-700 text-white'} w-32 rounded py-2 `}
                        onClick={deleteRow}
                        disabled={deleteDisabled}
                    >
                        Delete
                        {progress!=100&&<div
                            className='bg-red-600 h-0.5 rounded-full'
                            style={{ width: `${progress}%` }}
                            ></div>}
                    </button>
                    <button
                        className='w-32 rounded hover:text-white py-2 bg-success text-green-500 border border-green-500 hover:bg-green-500'
                        onClick={handleClose4}
                    >
                        Cancel
                    </button>
                </div>
    </>
  )
}

export default DeleteModal